import ActionsDomain from "../../pages/libraries/components/DomainManagement/ActionsDomain";
import ActionsTopology from "../../pages/treatments/ActionsTopology";

interface IActions {
  element: any;
  type: string;
}

const Actions = ({ type, element }: IActions) => {
  switch (type) {
    case "domaine":
      return <ActionsDomain domaine={element} />;
    case "topologies":
        return ActionsTopology(element)
    default:
      return <></>;
  }
};

export default Actions;
